// @flow

import React from 'react';

import { useCurrentAccountId } from '@zapier/design-system-revenue';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { extractParams } from '@zapier/url-utils';

import { paymentSourceMethods } from '@zapier/payment/src/types';
import usePaymentSourceState from './hooks/usePaymentSourceState';
import { PaymentMethodsSection } from './PaymentMethodsSection';
import { Skeleton } from './Skeleton';
import { apiKeys } from './apiKeys';

type Props = {
  autoEdit?: boolean,
  editInModal?: boolean,
  onDone?: () => void,
  // $FlowFixMe
  onSaveSuccess?: () => void,
};

export const PaymentApp = (props: Props) => {
  const { trackEvent } = useTrackingContext();
  const { accountId } = useCurrentAccountId();
  const startEdit = Boolean(
    extractParams(window.location.href)?.section ===
      paymentSourceMethods.card || props.autoEdit
  );

  const {
    currentSource,
    error,
    forceCardUpdate,
    isEditing,
    isLoading,
    isSaving,
    method,
    onCancelEdit,
    onEdit,
    onError,
    onHideSuccessMessage,
    onSave,
    onSelectMethod,
    showSuccessMessage,
    supportedMethods,
  } = usePaymentSourceState({
    accountId,
    onDone: props.onDone,
    // $FlowFixMe
    onSaveSuccess: props.onSaveSuccess,
    onTrack: trackEvent,
    startEdit,
  });

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <PaymentMethodsSection
      apiKeys={{
        braintree: apiKeys.braintreePubKey,
        stripe: apiKeys.stripePubKey,
      }}
      currentMethod={method}
      editInModal={Boolean(props.editInModal)}
      error={error}
      forceCardUpdate={forceCardUpdate}
      hasPaymentSource={Boolean(currentSource)}
      isEditing={isEditing}
      isEditingInFlight={isSaving}
      onCancelEdit={onCancelEdit}
      onEdit={onEdit}
      onErrorEdit={onError}
      onHideSuccessMessage={onHideSuccessMessage}
      onSaveEdit={onSave}
      onSelectSource={onSelectMethod}
      savedSource={currentSource}
      showChangeSuccessMessage={showSuccessMessage}
      supportedMethods={supportedMethods}
    />
  );
};
